import { MessageCircle, Volume2, Square, Highlighter } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PDFTextActions({
  showTextActions,
  selectionRects,
  selectedText,
  textActionsRef,
  textActionPosition,
  renderTextActions,
  selectionAnchor,
  clearTextSelection,
  onAskBudleeAI,
  handleAskBudleeAIClick,
  handleExplainClick,
  isReading,
  handleReadAloudClick,
  addHighlight,
  handleHighlightClick,
}) {
  return (
    <>

      {/* Only render overlay if actively selecting text */}
      {showTextActions && selectionRects.length > 0 ? (
        <div className="fixed inset-0 pointer-events-none z-40">
          {selectionRects.map((r, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <div
              key={idx}
              style={{
                position: 'absolute',
                top: `${r.top}px`,
                left: `${r.left}px`,
                width: `${r.width}px`,
                height: `${r.height}px`,
                background: 'rgba(59, 130, 246, 0.25)',
                borderRadius: '3px',
                boxShadow: '0 0 0 1px rgba(59, 130, 246, 0.3)',
                animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
              }}
            />
          ))}
        </div>
      ) : null}

      {showTextActions && selectedText && (
        <div
          ref={textActionsRef}
          className="fixed z-50 flex items-center gap-2 text-action-buttons"
          style={{
            top: `${textActionPosition.top}px`,
            left: `${textActionPosition.left}px`,
            transform: 'translateX(-50%)'
          }}
          onClick={(e) => {
            console.log('🔘 Button container clicked');
            e.stopPropagation();
          }}
        >
          {(() => {
            console.log('🎨 RENDERING BUTTONS at', textActionPosition);
            return null;
          })()}
          {typeof renderTextActions === 'function' ? (
            renderTextActions({
              selectedText,
              selectionAnchor,
              clearSelection: clearTextSelection,
            })
          ) : (
            <>
              {onAskBudleeAI && (
                <Button
                  onClick={handleAskBudleeAIClick}
                  size="sm"
                  className="bg-gradient-to-r from-[hsl(var(--green-bright))] to-[hsl(var(--teal-vivid))] hover:from-[hsl(var(--teal-vivid))] hover:to-[hsl(var(--green-bright))] text-[hsl(var(--main-bg))] font-bold shadow-lg animate-pulse"
                >
                  <img src="/logo.png" alt="Budlee" className="w-3 h-3 mr-1 rounded-full" />
                  Talk to Budlee
                </Button>
              )}
              {onAskBudleeAI && (
                <Button
                  onClick={handleExplainClick}
                  size="sm"
                  variant="outline"
                  className="bg-[hsl(var(--card-bg))] border-[hsl(var(--card-border))] text-foreground hover:bg-blue-500 hover:border-blue-500 hover:text-white shadow-lg transition-all"
                >
                  <MessageCircle className="w-3 h-3 mr-1" />
                  Explain
                </Button>
              )}
              <Button
                onClick={handleReadAloudClick}
                size="sm"
                variant="outline"
                className={`border-[hsl(var(--card-border))] shadow-lg transition-all ${isReading
                  ? 'bg-red-500 border-red-500 text-white hover:bg-red-600 hover:border-red-600'
                  : 'bg-[hsl(var(--card-bg))] text-foreground hover:bg-purple-500 hover:border-purple-500 hover:text-white'
                  }`}
              >
                {isReading ? (
                  <>
                    <Square className="w-3 h-3 mr-1" />
                    Stop
                  </>
                ) : (
                  <>
                    <Volume2 className="w-3 h-3 mr-1" />
                    Read aloud
                  </>
                )}
              </Button>
              {addHighlight && (
                <Button
                  onClick={handleHighlightClick}
                  size="sm"
                  variant="outline"
                  className="bg-[hsl(var(--card-bg))] border-[hsl(var(--card-border))] text-foreground hover:bg-yellow-500 hover:border-yellow-500 hover:text-white shadow-lg transition-all"
                >
                  <Highlighter className="w-3 h-3 mr-1" />
                  Highlight
                </Button>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
}
